// Only offline prototype entry points register builders. Production is empty.
const builders = new Map();
export function registerLocalVisual(id, build) { builders.set(id, build); }
export function getLocalVisual(id) { return builders.get(id); }
